import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "trending" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "pill-row" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = {
  key: 0,
  class: "empty"
}
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "pill-row" }
const _hoisted_8 = { class: "count" }
const _hoisted_9 = {
  key: 0,
  class: "empty"
}

import { onMounted, ref } from 'vue';
import SearchService, { TrendingTerm } from '@/services/SearchService';


export default /*@__PURE__*/_defineComponent({
  __name: 'TrendingList',
  props: {
    limit: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const tagTerms = ref<TrendingTerm[]>([]);
const keyTerms = ref<TrendingTerm[]>([]);
const loadingTag = ref(true);
const loadingKey = ref(true);

onMounted(async () => {
    // Fetch both in parallel
    try {
        const [tagRes, keyRes] = await Promise.all([
            SearchService.trending('tag', props.limit ?? 20),
            SearchService.trending('key', props.limit ?? 20),
        ]);
        tagTerms.value = tagRes.terms ?? [];
        keyTerms.value = keyRes.terms ?? [];
    } finally {
        loadingTag.value = false;
        loadingKey.value = false;
    }
});

function select(type: 'tag' | 'key', term: string) {
    emit('select', { type, term });
}

function formatCompact(n?: number) {
    const v = typeof n === 'number' ? n : 0;
    try {
        return Intl.NumberFormat(undefined, { notation: 'compact' }).format(v);
    } catch {
        // Basic fallback
        if (v >= 1_000_000) return (v / 1_000_000).toFixed(1) + 'M';
        if (v >= 1_000) return (v / 1_000).toFixed(1) + 'k';
        return String(v);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "section-title" }, "Trending Tags", -1)),
      _createElementVNode("div", _hoisted_3, [
        (loadingTag.value)
          ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
              key: 0,
              type: "chip, chip, chip, chip, chip",
              class: "mb-2"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagTerms.value, (t) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  key: 'tag-' + t.term,
                  class: "pill",
                  variant: "elevated",
                  color: "primary",
                  onClick: ($event: any) => (select('tag', t.term))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" #" + _toDisplayString(t.term) + " ", 1),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(formatCompact(t.hot_score)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128)),
              (!tagTerms.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No trending tags yet"))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "section-title" }, "Trending Keywords", -1)),
      _createElementVNode("div", _hoisted_7, [
        (loadingKey.value)
          ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
              key: 0,
              type: "chip, chip, chip, chip, chip",
              class: "mb-2"
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyTerms.value, (t) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  key: 'key-' + t.term,
                  class: "pill",
                  variant: "tonal",
                  color: "secondary",
                  onClick: ($event: any) => (select('key', t.term))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(t.term) + " ", 1),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(formatCompact(t.hot_score)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128)),
              (!keyTerms.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "No trending keywords yet"))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ])
  ]))
}
}

})